// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1FntB","content":"styles_content__3szyy","checkbox":"styles_checkbox__1kUCB","checkboxLabel":"styles_checkboxLabel__1hwnG"};